import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d8a2182c")

_pushScopeId("data-v-d8a2182c")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "bg_load" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "wrapper" }, [
  /*#__PURE__*/_createVNode("div", { class: "inner" }, [
    /*#__PURE__*/_createVNode("span", null, "L"),
    /*#__PURE__*/_createVNode("span", null, "o"),
    /*#__PURE__*/_createVNode("span", null, "a"),
    /*#__PURE__*/_createVNode("span", null, "d"),
    /*#__PURE__*/_createVNode("span", null, "i"),
    /*#__PURE__*/_createVNode("span", null, "n"),
    /*#__PURE__*/_createVNode("span", null, "g"),
    /*#__PURE__*/_createVNode("img", {
      src: "/img/sample.gif",
      style: {"width":"50px","vertical-align":"middle"}
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
})